<template>
	<div class="layout-main" :class="{'--with-top-banner': isSurveyBannerShown}">
    <div class="layout-main__top-banner">
      <banner-line-survey/>
      <!-- промо-баннер из админки (TOP_BANNER) временно отключён, вернуть при необходимости:
      <banner-line-promo/> -->
    </div>
		<the-header/>
    <banner-line/>
		<v-main>
			<transition name="route" mode="out-in">
				<router-view />
			</transition>
		</v-main>
    <cookies-popup />
		<the-footer />
	</div>
</template>

<script>
    import TheHeader from './the-header';
    import TheFooter from './the-footer';
    import BannerLine from "@/components/banner-line.vue";
    import CookiesPopup from "@/components/cookies-popup.vue";
    import BannerLineSurvey from '@/components/survey/banner-line-survey.vue';
    import surveyBanner from '@/mixins/survey-banner';
    // import BannerLinePromo from '@/components/banner-line-promo.vue';
    // import promoBanner from '@/mixins/promo-banner';
    //import GlobalBanner from "./global-banner";
    //import BasketPopup from "@/views/basket/basket-popup";

    export default {
        name: "layout-main",
        components: {
          CookiesPopup,
          BannerLine,
          BannerLineSurvey,
          // BannerLinePromo,
            //GlobalBanner,
            //BasketPopup,
            TheHeader,
            TheFooter
        },
        mixins: [surveyBanner],
        // mixins: [promoBanner],
    }
</script>

<style lang="scss">
.layout-main {
  // высота баннера над шапкой = пропорции его картинок (мобильная 319x71, десктоп 80x7), 0 - баннер не показан.
  // Пропорции должны совпадать с aspect-ratio в banner-line-survey.vue (для промо-баннера: 960x220 и 2000x172)
  --top-banner-height: 0px;

  &.--with-top-banner {
    --top-banner-height: calc(100vw * 71 / 319);

    @include up($md) {
      --top-banner-height: calc(100vw * 7 / 80);
    }
  }

  // баннер в потоке над шапкой на всех страницах: шапка (fixed) сдвигается на его высоту и при скролле
  // прилипает к верху. Высота плавно раскрывается/схлопывается.
  &__top-banner {
    overflow: hidden;
    height: var(--top-banner-height);
    @include transition-long();
  }
}
</style>
